(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("underscore"), require("urijs"), require("@bingads-webui/js-data-patch"));
	else if(typeof define === 'function' && define.amd)
		define(["underscore", "urijs", "@bingads-webui/js-data-patch"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("underscore"), require("urijs"), require("@bingads-webui/js-data-patch")) : factory(root["underscore"], root["urijs"], root["@bingads-webui/js-data-patch"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__7__, __WEBPACK_EXTERNAL_MODULE__10__, __WEBPACK_EXTERNAL_MODULE__132__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 129);
/******/ })
/************************************************************************/
/******/ ({

/***/ 10:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__10__;

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(130);


/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "JsDataRestStore", {
  enumerable: true,
  get: function get() {
    return _jsDataRestStore.JsDataRestStore;
  }
});
Object.defineProperty(exports, "JsDataRestAdapter", {
  enumerable: true,
  get: function get() {
    return _jsDataRestAdapter.JsDataRestAdapter;
  }
});

var _jsDataRestStore = __webpack_require__(131);

var _jsDataRestAdapter = __webpack_require__(133);

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JsDataRestStore = void 0;

var _jsDataPatch = _interopRequireDefault(__webpack_require__(132));

var _jsDataRestAdapter = __webpack_require__(133);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This class is a extension of JSData DS(data store)
 * @param {object} restfulService - (required) a wrapper of ajax request
 */
class JsDataRestStore extends _jsDataPatch.default.DS {
  constructor({
    restfulService
  }) {
    super().registerAdapter('rest', new _jsDataRestAdapter.JsDataRestAdapter({
      restfulService
    }), {
      default: true
    });
  }
  /**
   * Define resource using JSData data store
   * @param {string} resourceName - (required) the name of resource
   * @param {object} uriPath - (required) the default uri path for each resource
   * @param {string} primaryKey - (optional) the primary key for the resource, default is 'id'
   *
   * @returns {object} the JsData resource
   */


  defineRestResource(resourceName, {
    uriPath,
    primaryKey = 'id'
  }) {
    if (this.definitions && this.definitions[resourceName]) {
      return this.definitions[resourceName];
    }

    return this.defineResource({
      name: resourceName,
      meta: {
        uriPath
      },
      idAttribute: primaryKey
    });
  }

}

exports.JsDataRestStore = JsDataRestStore;

/***/ }),

/***/ 132:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__132__;

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JsDataRestAdapter = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(7));

var _urijs = _interopRequireDefault(__webpack_require__(10));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Generate uri for restful ajax request
 * @param {object} definition - resource definition
 * @param {object} properties - query options collection
 * @param {object} options - options collection to help generate URL
 *
 * @returns {string} the uri for restful ajax request
 */
const generateUri = function generate(definition, properties, options) {
  let query = '';

  if (!_underscore.default.isEmpty(properties)) {
    const queryParam = {};

    _underscore.default.each(properties, (value, key) => {
      switch (key) {
        case 'orderBy':
          if (_underscore.default.isString(value)) {
            queryParam.$orderby = `${value} asc`;
          } else if (_underscore.default.isArray(value) && _underscore.default.isArray(value[0]) && value[0].length > 1) {
            queryParam.$orderby = `${value[0][0]} ${value[0][1].toLowerCase()}`;
          } else if (_underscore.default.isObject(value)) {
            const name = _underscore.default.keys(value)[0];

            const direction = value[name] > 0 ? 'asc' : 'desc';
            queryParam.$orderby = `${name} ${direction}`;
          }

          break;
        // Todo: may need a better design of this part,using 'query' here is for compatibility.

        case 'query':
          _underscore.default.extend(queryParam, value);

          break;

        case 'limit':
          if (!_underscore.default.isNumber(value) || _underscore.default.isNaN(value)) {
            throw new TypeError('limit must be a number and not NaN');
          } else if (value !== Number.MAX_VALUE) {
            queryParam.$top = value;
          }

          break;

        case 'offset':
          queryParam.$skip = value;
          break;

        default:
          queryParam[key] = value;
          break;
      }
    });

    query = `?${_urijs.default.buildQuery(queryParam, false, false)}`;
  }

  let path = definition.meta.uriPath;

  if (options && !_underscore.default.isEmpty(options.pathExtension)) {
    _underscore.default.each(options.pathExtension, (value, key) => {
      path = `${path}/${key}/${value}`;
    });
  }

  return `${path}${query}`;
};

const checkAndAddPrimaryKey = (primaryKey, items) => {
  const queryId = _underscore.default.uniqueId('query-'); // JSData requires ID for every resource, some calls won't return items with ID
  // We add ID here to fit JSData requirement before JSData inject happens


  _underscore.default.each(items, (item, index) => {
    if (!_underscore.default.has(item, primaryKey)) {
      item[primaryKey] = `${queryId}-${index}`; // eslint-disable-line no-param-reassign
    }
  });

  return items;
};
/**
 * This class is a extension of JSData DS(data store)
 * @param {object} restfulService - (required) a wrapper of ajax request
 */


class JsDataRestAdapter {
  constructor({
    restfulService
  }) {
    this.restfulService = restfulService;
  }
  /**
   * implement of JSData API create
   * @param {object} definition - is a resource definition that would
   *                                         be returned by DS#defineResource
   * @param {object} attrs - properties with which to create the item
   * @param {object} [options] - would be options argument that was passed into
   *                             function DS method that is calling the adapter method
   *
   * @returns {promise} will return a promise
   */


  create(definition, attrs, options) {
    // Must resolve the promise with the created item
    return this.restfulService.post(generateUri(definition, {}, options), attrs, options);
  }
  /**
   * implement of JSData API find
   * @param {object} definition - is a resource definition that would
   *                                         be returned by DS#defineResource
   * @param {string|number} id - primary key of the item to retrieve
   * @param {object} [options] - would be options argument that was passed into
   *                             function DS method that is calling the adapter method
   *
   * @returns {promise} will return a promise
   */


  find(definition, id, options) {
    // Must return a promise that resolves with the found item
    return this.restfulService.get(generateUri(definition, {
      [definition.idAttribute]: id
    }, options), options);
  }
  /**
   * implement of JSData API findAll
   * @param {object} definition - is a resource definition that would
   *                              be returned by DS#defineResource
   * @param {object} params - query parameters for selecting items from the collection
   * @param {object} [options] - would be options argument that was passed into
   *                             function DS method that is calling the adapter method
   *
   * @returns {Promise.<Object[]>} Promise of item list. ID will be added to item if it's missing
   *                               total and other properties will be added as well.
   */


  findAll(definition, params, options) {
    // Must return a promise that resolves with the found items
    return this.restfulService.get(generateUri(definition, params, options), options).then(res => {
      if (options && _underscore.default.isFunction(options.preProcess)) {
        // eslint-disable-next-line no-param-reassign
        res = options.preProcess(res);
      }

      const addPropertyTotalCount = obj => Object.defineProperty(obj, 'totalCount', {
        value: res.total,
        enumerable: false
      });

      const addPropertyRaw = obj => Object.defineProperty(obj, 'raw', {
        value: res,
        enumerable: false
      });

      const addProperties = _underscore.default.compose(addPropertyTotalCount, addPropertyRaw); // To handle different format response, some calls will return
      // {total: a number, value: a list of items},
      // For these cases we need change the value.


      const items = checkAndAddPrimaryKey(definition.idAttribute, _underscore.default.has(res, 'value') ? res.value : res);

      if (res.value && options.cacheResponse) {
        options.afterInject = _underscore.default.compose( // eslint-disable-line no-param-reassign
        options.afterInject || _underscore.default.identity, (innerOptions, injected) => addProperties(injected));
      } else {
        addProperties(items);
      }

      return items;
    });
  }
  /**
   * implement of JSData API update
   * @param {object} definition - is a resource definition that would
   *                              be returned by DS#defineResource
   * @param {string|number} id - primary key of the item to update
   * @param {object} attrs - properties with which to update the item.
   * @param {object} [options] - would be options argument that was passed into
   *                           function DS method that is calling the adapter method
   *
   * @returns {promise} will return a promise
   */


  update(definition, id, attrs, options) {
    // Must return a promise that resolves with the update items
    return this.restfulService.patch(generateUri(definition, {
      id
    }, options), attrs, options);
  }
  /**
   * implement of JSData API updateAll
   * @param {object} definition - is a resource definition that would
   *                              be returned by DS#defineResource
   * @param {object} attrs - the attributes which to update the resource.
   * @param {object} [params] - query parameters for selecting which items to update. Default: {}.
   * @param {object} [options] - would be options argument that was passed into
   *                             function DS method that is calling the adapter method
   *
   * @returns {Promise.<Object[]>} Promise of item list. ID will be added to item if it's missing
   */


  updateAll(definition, attrs, params, options) {
    return this.restfulService.patch(generateUri(definition, params, options), attrs, options).then(res => checkAndAddPrimaryKey(definition.idAttribute, _underscore.default.has(res, 'value') ? res.value : res));
  }
  /**
   * implement of JSData API destroy
   * @param {object} definition - is a resource definition that would
   *                              be returned by DS#defineResource
   * @param {string|number} id - primary key of the item to destroy
   * @param {object} [options] - would be options argument that was passed into
   *                             function DS method that is calling the adapter method
   *
   * @returns {promise} will return a promise
   */


  destroy(definition, id, options) {
    // Must return a promise
    return this.restfulService.delete(generateUri(definition, {
      id
    }, options), options);
  }
  /**
   * implement of JSData API destroyAll
   * @param {object} definition - is a resource definition that would
   *                              be returned by DS#defineResource
   * @param {object} params - query parameters for selecting which items to destroy
   * @param {object} [options] - would be options argument that was passed into
   *                             function DS method that is calling the adapter method
   *
   * @returns {promise} will return a promise
   */


  destroyAll(definition, params, options) {
    // Must return a promise
    return this.restfulService.delete(generateUri(definition, params, options), options);
  }

}

exports.JsDataRestAdapter = JsDataRestAdapter;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__7__;

/***/ })

/******/ });
});
